import { useState, useEffect } from "react";
import { useUpdateKlaviyoProperties } from "../hooks/useUpdateKlaviyoProperties";
import { Checkbox } from "@components/Checkbox";
import { SHOPPING_PREFS_DATA } from "./lib/constants";
import styles from "./styles/ShoppingPrefs.module.css";

export const ShoppingPrefs = ({ account, setSuccess }) => {
  const [values, setValues] = useState([]);
  const klaviyoUpdate = useUpdateKlaviyoProperties(account, setSuccess);

  useEffect(() => {
    if (account.klaviyoData.checkboxes) {
      setValues(account.klaviyoData.checkboxes)
    };
  }, []);

  const handleChange = (val) => {
    const hasValue = values.includes(val);

    if (!hasValue) setValues([...values, val]);

    if (hasValue) {
      const updated = values.filter(value => value !== val);
      setValues(updated);
    }
  }

  const handleSubmit = () => {
    klaviyoUpdate.mutate({
      $email: account.klaviyoData.$email,
      checkboxes: values
    });
  }

  const Save = () => {
    return (
      <input
        className={`${styles.button} ${styles.primary}`}
        type="button"
        value="Save"
        onClick={handleSubmit}
      />
    )
  }

  return (
    <form className={styles.form}>
      <section className={styles.container}>
        {SHOPPING_PREFS_DATA.map(item => {
          const hasValue = values.includes(item.value);
          return (
            <div key={item.value} className={styles.lineItem}>
              <Checkbox
                id={item.label}
                name={item.label}
                value={hasValue}
                checked={hasValue}
                onChange={() => handleChange(item.value)}
                label={item.label}
                wideRow
              />
            </div>
          )
        })}
      </section>
      <Save />
    </form>
  )
}